import useFetch from '@hooks/useFetch';

export const getKey = (goalUID) => `v1/user/sales_connect/?goal_uid=${goalUID}`;

const useTTUQuestions = (goalUID) => {
  const key = getKey(goalUID);
  const { data: questions, ...rest } = useFetch(key);
  return { key, questions, ...rest };
};

export default useTTUQuestions;
